// Post Service - Demo Mode
// Uses localStorage for persistence in demo mode

import {
  saveMockPost,
  getSavedPosts,
  deleteMockPost,
  updateMockPost
} from '../data/mockResponses.js';

class PostService {
  static async createPost(data) {
    console.log('Demo Mode: Creating post');
    const post = await saveMockPost(data);
    return {
      success: true,
      data: post
    };
  }

  static async getAllPosts(params = {}) {
    console.log('Demo Mode: Getting all posts');
    const posts = await getSavedPosts();

    // Apply basic filtering if params provided
    let filteredPosts = [...posts];

    if (params.status) {
      filteredPosts = filteredPosts.filter(p => p.status === params.status);
    }

    if (params.language) {
      filteredPosts = filteredPosts.filter(p => p.language === params.language);
    }

    // Sort by creation date (newest first)
    filteredPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return {
      success: true,
      data: {
        posts: filteredPosts,
        total: filteredPosts.length
      }
    };
  }

  static async getPostById(id) {
    console.log('Demo Mode: Getting post by ID:', id);
    const posts = await getSavedPosts();
    const post = posts.find(p => p.id === id);

    if (!post) {
      return {
        success: false,
        error: { message: 'Post not found' }
      };
    }

    return {
      success: true,
      data: post
    };
  }

  static async updatePost(id, data) {
    console.log('Demo Mode: Updating post:', id);
    try {
      const updatedPost = await updateMockPost(id, data);
      return {
        success: true,
        data: updatedPost
      };
    } catch (error) {
      return {
        success: false,
        error: { message: error.message }
      };
    }
  }

  static async deletePost(id) {
    console.log('Demo Mode: Deleting post:', id);
    await deleteMockPost(id);
    return {
      success: true
    };
  }

  static async getPostVersions(id) {
    console.log('Demo Mode: Getting post versions (not available in demo)');
    // Versions not tracked in demo mode
    return {
      success: true,
      data: []
    };
  }
}

export default PostService;
